import {Component, Input, OnInit} from "@angular/core";
import {Project} from "../../../services/model/projects.model";
import {environment} from "../../../../environments/environment";
import {ProjectService} from "../../../services/project.service";
import {ActivatedRoute} from "@angular/router";
import {NotificationService} from "../../../services/notification.service";
import {GlobalService} from '../../../services/global.service';

@Component({
    selector: 'app-parts',
    templateUrl: './parts.component.html',
})
export class PartsComponent implements OnInit{
    env = environment;
    is_edit: boolean;
    items: object;
    id: string;
    @Input('project') project: Project;

    constructor(
        private ProjectServ: ProjectService,
        private activeR: ActivatedRoute,
        private notifServ: NotificationService,
        public globalServ: GlobalService
    ){
        this.items = {};
        this.is_edit = false;
        this.id = this.activeR.snapshot.params['id'];
    }

    ngOnInit(){
    }

    changeStatus(event, item: string){
        this.items[item] = event.target.checked
    }

    toggleEdit(status: boolean){
        if(!status){
            this.items = {};
        }
        this.is_edit = status;
    }

    save(){
        for(let item in this.items){
            this.project[item] = this.items[item];
        }

        if(this.project[this.env.production_flag]){
            this.project.status = 3;
        }else{
            this.project.status = 1;
        }

        this.ProjectServ.updateProject(this.id, this.project).then(
            r => {
                this.toggleEdit(false);
                this.notifServ.sendSuccess( 'Project parts have been saved');
            }
        )

    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/project-parts/parts.component.ts